export default "__VITE_ASSET__CC4i3LoP__"